<!-- 選択できない場合の表示 -->
<div
  *ngIf="isUnavailable(seatNumber)"
  class="p-seatmap__seat"
  [class.p-seatmap__seat--couchii3]="isThreeColumnCouchSeat"
  [class.p-seatmap__seat--couchii4]="!isThreeColumnCouchSeat"
  [class.is-unchangeable]="false"
  [class.is-unavailable]="isUnavailable(seatNumber)"
>
  <span class="u-visually-hidden">{{ seatNumber }}</span>
  <span class="p-seatmap__seat-status"
    ><img
      src="assets/images/seat_unavailable.svg"
      alt="{{ 'm_static_message-label.unselectable' | staticMsg }}"
      width="14"
      height="14"
  /></span>
</div>

<button
  *ngIf="!isUnavailable(seatNumber)"
  id="{{ seatNumber }}"
  class="p-seatmap__seat p-seatmap__seat--free"
  [class.p-seatmap__seat--couchii3]="isThreeColumnCouchSeat"
  [class.p-seatmap__seat--couchii4]="!isThreeColumnCouchSeat"
  aria-live="polite"
  (click)="onClickSeat(seatNumber)"
  [class.is-unchangeable]="isChangeRestricted(seatNumber)"
  [class.is-selected]="isSelected(seatNumber) && !isChangeRestricted(seatNumber)"
  [class.seat-disabled]="isNotClickable()"
  [class.is-before-change]="isBeforeChange(seatNumber)"
  [disabled]="isNotClickable()"
>
  <!-- 座席番号 -->
  <span class="u-visually-hidden">{{ seatNumber }}</span>

  <ng-container *ngIf="isSelected(seatNumber); else notSelectedSeat">
    <!-- 選択中 -->
    <span
      class="p-seatmap__seat-status u-visually-hidden"
      innerHTML="{{ 'm_static_message-label.selecting' | staticMsg }}"
    ></span>
  </ng-container>
  <ng-template #notSelectedSeat>
    <!-- 選択可 -->
    <span
      *ngIf="!isUnavailable(seatNumber)"
      class="p-seatmap__seat-status u-visually-hidden"
      innerHTML="{{ 'm_static_message-label.selectable' | staticMsg }}"
    ></span>
  </ng-template>

  <!-- 変更前 -->
  <ng-container *ngFor="let passengerId of isLeftSide ? passengerIdList?.slice()?.reverse() : passengerIdList">
    <span
      *ngIf="isBeforeChangeByPassenger(seatNumber, passengerId)"
      class="p-seatmap__seat-status u-visually-hidden"
      innerHTML="{{ 'm_static_message-label.changeBeforeCouchSeat' | staticMsg }}"
    ></span>

    <span *ngIf="isBeforeChangeByPassenger(seatNumber, passengerId)" class="p-seatmap__seat-passenger">
      <span class="p-seatmap__seat-passenger-num">
        {{ getPassengerIndex(passengerId) !== undefined ? getPassengerIndex(passengerId)! + 1 : '' }}
      </span>
    </span>
  </ng-container>

  <!--
    カウチ席（3列）
  -->
  <span
    *ngIf="false"
    class="p-seatmap__seat-info u-visually-hidden"
    innerHTML="{{ 'm_static_message-reader.couch.threeColumns' | staticMsg }}"
  ></span>

  <!--
    カウチ席（4列）
  -->
  <span
    *ngIf="false"
    class="p-seatmap__seat-info u-visually-hidden"
    innerHTML="{{ 'm_static_message-reader.couch.fourColumns' | staticMsg }}"
  ></span>

  <!-- 搭乗者 -->
  <ng-container *ngFor="let passenger of isLeftSide ? passengerIdList?.slice()?.reverse() : passengerIdList">
    <span *ngIf="isSelectedByPassenger(passenger)" class="p-seatmap__seat-passenger">
      <span class="p-seatmap__seat-passenger-num">
        {{ getPassengerIndex(passenger) !== undefined ? getPassengerIndex(passenger)! + 1 : '' }}
      </span>
    </span>
  </ng-container>
</button>
